import { Directive, ElementRef, Input } from '@angular/core';

declare var jquery:any;
declare var $ :any;

@Directive({
  selector: '[myCool]'
})

export class CoolDirective {
    constructor(el: ElementRef) {
       $(el.nativeElement).click(function (e) {
            var $this = $(this);
            var $content = $this.next();

            if ($($this.parents('ul')[0]).hasClass('list')) {
                var $not = $(e.target).hasClass('menu-toggle') ? e.target : $(e.target).parents('.menu-toggle');

                $.each($('.menu-toggle.toggled').not($not).next(), function (i, val) {
                    if ($(val).is(':visible')) {
                        $(val).prev().toggleClass('toggled');
                        $(val).slideUp();
                    }
                });
            }

            $this.toggleClass('toggled');
            $content.slideToggle(320);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/cool.directive.ts